(function () {
  Flint.file("views/testimonial.js", function (require) {
    Flint.staticStyles("Testimonial", {
      "$quoteBody": "#_flintapp quoteBody.Testimonial, #_flintapp .Testimonial.quoteBody, #_flintapp .ViewTestimonial.quoteBody, #_flintapp .Testimonial > .quoteBody",
      "$quoteSec": "#_flintapp quoteSec.Testimonial, #_flintapp .Testimonial.quoteSec, #_flintapp .ViewTestimonial.quoteSec, #_flintapp .Testimonial > .quoteSec",
      "$personSec": "#_flintapp personSec.Testimonial, #_flintapp .Testimonial.personSec, #_flintapp .ViewTestimonial.personSec, #_flintapp .Testimonial > .personSec",
      "$personPic": "#_flintapp personPic.Testimonial, #_flintapp .Testimonial.personPic, #_flintapp .ViewTestimonial.personPic, #_flintapp .Testimonial > .personPic",
      "$personDetails": "#_flintapp personDetails.Testimonial, #_flintapp .Testimonial.personDetails, #_flintapp .ViewTestimonial.personDetails, #_flintapp .Testimonial > .personDetails"
    }, {
      "$quoteBody": {
        background: 'white',
        borderRadius: 8,
        padding: 20,
        fontWeight: 'bold'
      },
      "$quoteSec": {
        zIndex: 1
      },
      "$personSec": {
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
        top: -10
      },
      "$personPic": {
        width: 70,
        height: 70,
        borderRadius: '50%',
        marginRight: 16
      },
      "$personDetails": {
        color: 'white',
        fontWeight: 'bold'
      }
    });
    Flint.view("Testimonial", function (view, on, $) {
      var pro = initPro(view, {
        children: atom(),
        name: atom(),
        location: atom(),
        picUrl: atom()
      });view.render(function () {
        return view.el(
          ["quoteSec", 1],
          null,
          view.el(
            ["quoteBody", 1],
            null,
            pro.children.get()
          ),
          view.el(["Triangle", 1], { className: "quoteTriangle", pointAngle: "down", style: {
              width: 14,
              height: 20,
              marginLeft: 22,
              color: 'white'
            } })
        );
      });view.render(function () {
        return view.el(
          ["personSec", 1],
          null,
          view.el(["img", 1], { className: "personPic", src: pro.picUrl.get() }),
          view.el(
            ["personDetails", 1],
            null,
            view.el(
              ["personName", 1],
              null,
              pro.name.get()
            ),
            view.el(
              ["personLoc", 1],
              null,
              pro.location.get()
            )
          )
        );
      });

      "1ed666d9";
      "83926c3a";
      "166e03c4";
      "f45c108a";
      "42ba485b";
    });
  })
})();
//# sourceMappingURL=testimonial.js.map
